import React from 'react';
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import API_PATH from "../../constants/config.json";
const axios = require('axios');
const API_URL = process.env.REACT_APP_BASE_URL;

//Start Css code ...
const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    width: '100%',
    padding: '0px',
    '& .Mui-selected': {
      background: 'rgba(36, 97, 142, 1)',
      color: "#fff !important"
    },
    '& .MuiTabs-root': {
      minHeight: '25px',
      marginTop: "10px"
    },
    '& .MuiTabs-flexContainer': {
      display: 'inline-block',
    },
    '& .MuiTab-root': {
      minWidth: '140px',
      padding: '3px 15px 2px',
      lineHeight: 'normal',
    },
    '& .PrivateTabIndicator-colorPrimary-14': {
      backgroundColor: '#24618E',
    },
    '& .MuiAppBar-colorDefault': {
      marginBottom: '15px',
      boxShadow: 'none',
      background: '#fff',
      '& .MuiButtonBase-root': {
        border: '1px solid #24618E',
        borderRadius: '8px 8px 0px 0px',
        minHeight: 'auto',
        color: '#333',
        textTransform: 'capitalize',
        borderBottom: 'none',
      },
    },
    '& h5': {
      fontSize: '18px',
      margin: '0px 0 10px',
    },
    '& .MuiAppBar-root': {
      marginBottom: '0px !important'
    },
    '& .MuiTabs-indicator': {
      backgroundColor: 'transparent !important',
    }
  },
  layerBlock: {
    '& h4': {
      fontSize: '20px',
      margin: '10px 0',
    },
  },
  mainbtnDiv: {
    border: '1px solid rgba(0, 167, 93, 1)',
    borderTop: '1px solid rgba(0, 167, 93, 1)',
    borderRadius: '0px 5px 5px 5px',
    height: 'auto',
    '& .focusBtn': {
      color: "#fff",
      background: '#24618E',
    },
    '& .left': {
      width: '37%',
      float: 'left',
    },
    '& .right': {
      width: '63%',
      float: 'right',
    },
    overflow: "hidden",
    marginBottom: "5px"
  },
  intersectionDrop: {
    padding: '5px',
    width: '100%',
    '@media only screen and (max-width: 3500px)': {
      fontSize: '14pt',
    },
    '@media only screen and (min-width: 3501px)': {
      fontSize: '24pt',
    },
  },

  turningCountData: {
    width: '100%',
    float: 'left',
    position: 'relative',
    textAlign: 'center',
    cursor: 'default',
    '@media only screen and (max-width: 3500px)': {
      '& .arrowImg': {
        width: '18px',
        position: 'absolute',
        top: '30px',
        right: '40px',
        fontSize: '15pt',
      },
      '& span': {
        fontSize: '10pt',
        width: '40px',
        cursor: 'default',
      },
      '& span.amnbIn': {
        top: '35px',
        left: '140px',
        position: 'absolute',
      },
      '& span.amNbLeft': {
        top: '95px',
        left: '242px',
        position: 'absolute',
      },
      '& span.amnbEx': {
        top: '35px',
        left: '243px',
        position: 'absolute',
      },
      '& span.amNbMiddle': {
        top: '95px',
        left: '190px',
        position: 'absolute',
      },
      '& span.amNbRight': {
        top: '95px',
        left: '140px',
        position: 'absolute',
      },
      '& span.amsbIn': {
        top: '385px',
        left: '242px',
        position: 'absolute',
      },
      '& span.amsbEx': {
        top: '385px',
        left: '138px',
        position: 'absolute',
      },
      '& span.amebIn': {
        top: '155px',
        left: '365px',
        position: 'absolute',
      },
      '& span.amebEx': {
        top: '255px',
        left: '365px',
        position: 'absolute',
      },
      '& span.amwbIn': {
        top: '347px',
        left: '25px',
        position: 'absolute',
      },
      '& span.amwbIn': {
        top: '255px',
        left: '15px',
        position: 'absolute',
      },
      '& span.amwbEx': {
        top: '155px',
        left: '15px',
        position: 'absolute',
      },
      '& span.amSbLeft': {
        top: '320px',
        left: '141px',
        position: 'absolute',
      },
      '& span.amEbLeft': {
        top: '256px',
        left: '300px',
        position: 'absolute',
      },
      '& span.amWbLeft': {
        top: '156px',
        left: '80px',
        position: 'absolute',
      },
      '& span.amSbRight': {
        top: '320px',
        left: '234px',
        position: 'absolute',
      },
      '& span.amEbRight': {
        top: '155px',
        left: '300px',
        position: 'absolute',
      },
      '& span.amWbRight': {
        top: '255px',
        left: '80px',
        position: 'absolute',
      },
      '& span.amCenterData': {
        top: '195px',
        left: '186px',
        position: 'absolute',
        width: '50px !important',
        padding: '13px 0',        
      },
      '& span.amSbMiddle': {
        top: '320px',
        left: '191px',
        position: 'absolute',
      },
      '& span.amEbMiddle': {
        top: '205px',
        left: '300px',
        position: 'absolute',
      },
      '& span.amWbMiddle': {
        top: '204px',
        left: '80px',
        position: 'absolute',
      },
      '& span.nUturn': {
        top: '20px',
        left: '190px',
        position: 'absolute',
      },
      '& span.sUturn': {
        top: '395px',
        left: '191px',
        position: 'absolute',
      },
      '& span.eUturn': {
        top: '205px',
        left: '385px',
        position: 'absolute',
      },
      '& span.wUturn': {
        top: '204px',
        left: ' 0px',
        position: 'absolute',
      }
    },
    '@media only screen and (min-width: 3501px)': {
      '& .arrowImg': {
        width: '25px',
        position: 'absolute',
        top: '65px',
        right: '85px',
        fontSize: '25pt',
      },
      '& span': {
        fontSize: '18pt',
        width: '90px',
        cursor: 'default',
      },
      '& span.amnbIn': {
        top: '50px',
        left: '260px',
        position: 'absolute',
      },
      '& span.amNbLeft': {
        top: '165px',
        left: '430px',
        position: 'absolute',
      },
      '& span.amnbEx': {
        top: '50px',
        left: '420px',
        position: 'absolute',
      },
      '& span.amNbMiddle': {
        top: '165px',
        left: '340px',
        position: 'absolute',
      },
      '& span.amNbRight': {
        top: '165px',
        left: '253px',
        position: 'absolute',
      },
      '& span.amsbIn': {
        top: '670px',
        left: '426px',
        position: 'absolute',
      },
      '& span.amsbEx': {
        top: '670px',
        left: '258px',
        position: 'absolute',
      },
      '& span.amebIn': {
        top: '280px',
        left: '715px',
        position: 'absolute',
      },
      '& span.amebEx': {
        top: '440px',
        left: '715px',
        position: 'absolute',
      },
      '& span.amwbIn': {
        top: '440px',
        left: '-6px',
        position: 'absolute',
      },
      '& span.amwbEx': {
        top: '280px',
        left: '-6px',
        position: 'absolute',
      },
      '& span.amSbLeft': {
        top: '553px',
        left: '253px',
        position: 'absolute',
      },
      '& span.amEbLeft': {
        top: '430px',
        left: '570px',
        position: 'absolute',
      },
      '& span.amWbLeft': {
        top: '290px',
        left: ' 120px',
        position: 'absolute',
      },
      '& span.amSbRight': {
        top: '553px',
        left: '430px',
        position: 'absolute',
      },
      '& span.amEbRight': {
        top: '285px',
        left: '570px',
        position: 'absolute',
      },
      '& span.amWbRight': {
        top: '427px',
        left: ' 120px',
        position: 'absolute',
      },
      '& span.amCenterData': {
        top: '360px',
        left: '342px',
        position: 'absolute',
      },
      '& span.amSbMiddle': {
        top: '553px',
        left: '340px',
        position: 'absolute',
      },
      '& span.amEbMiddle': {
        top: '360px',
        left: '570px',
        position: 'absolute',
      },
      '& span.amWbMiddle': {
        top: '360px',
        left: ' 120px',
        position: 'absolute',
      },
    },
  },



  truckMovData: {
    width: '100%',
    float: 'left',
    position: 'relative',
    textAlign: 'center',
    cursor: 'default',
    '@media only screen and (max-width: 3500px)': {
      '& .arrowImg': {
        width: '18px',
        position: 'absolute',
        top: '30px',
        right: '40px',
        fontSize: '15pt',
      },
      '& span': {
        fontSize: '10pt',
        width: '40px',
        cursor: 'default',
      },
      '& span.amnbIn': {
        top: '35px',
        left: '140px',
        position: 'absolute',
      },
      '& span.amNbLeft': {
        top: '95px',
        left: '242px',
        position: 'absolute',
      },
      '& span.amnbEx': {
        top: '35px',
        left: '243px',
        position: 'absolute',
      },
      '& span.amNbMiddle': {
        top: '95px',
        left: '190px',
        position: 'absolute',
      },
      '& span.amNbRight': {
        top: '95px',
        left: '140px',
        position: 'absolute',
      },
      '& span.amsbIn': {
        top: '385px',
        left: '242px',
        position: 'absolute',
      },
      '& span.amsbEx': {
        top: '385px',
        left: '138px',
        position: 'absolute',
      },
      '& span.amebIn': {
        top: '155px',
        left: '365px',
        position: 'absolute',
      },
      '& span.amebEx': {
        top: '255px',
        left: '365px',
        position: 'absolute',
      },
      '& span.amwbIn': {
        top: '347px',
        left: '25px',
        position: 'absolute',
      },
      '& span.amwbIn': {
        top: '255px',
        left: '15px',
        position: 'absolute',
      },
      '& span.amwbEx': {
        top: '155px',
        left: '15px',
        position: 'absolute',
      },
      '& span.amSbLeft': {
        top: '320px',
        left: '141px',
        position: 'absolute',
      },
      '& span.amEbLeft': {
        top: '256px',
        left: '300px',
        position: 'absolute',
      },
      '& span.amWbLeft': {
        top: '156px',
        left: '80px',
        position: 'absolute',
      },
      '& span.amSbRight': {
        top: '320px',
        left: '234px',
        position: 'absolute',
      },
      '& span.amEbRight': {
        top: '155px',
        left: '300px',
        position: 'absolute',
      },
      '& span.amWbRight': {
        top: '255px',
        left: '80px',
        position: 'absolute',
      },
      '& span.amCenterData': {
        top: '195px',
        left: '186px',
        position: 'absolute',
        width: '50px !important',
        padding: '13px 0',        
      },
      '& span.amSbMiddle': {
        top: '320px',
        left: '191px',
        position: 'absolute',
      },
      '& span.amEbMiddle': {
        top: '205px',
        left: '300px',
        position: 'absolute',
      },
      '& span.amWbMiddle': {
        top: '204px',
        left: '80px',
        position: 'absolute',
      },
      '& span.nUturn': {
        top: '20px',
        left: '190px',
        position: 'absolute',
      },
      '& span.sUturn': {
        top: '395px',
        left: '191px',
        position: 'absolute',
      },
      '& span.eUturn': {
        top: '205px',
        left: '385px',
        position: 'absolute',
      },
      '& span.wUturn': {
        top: '204px',
        left: ' 0px',
        position: 'absolute',
      } 
    },
    '@media only screen and (min-width: 3501px)': {
      '& .arrowImg': {
        width: '25px',
        position: 'absolute',
        top: '50px',
        right: '85px',
        fontSize: '25pt',
      },
      '& span': {
        fontSize: '18pt',
        width: '90px',
        cursor: 'default',
      },
      '& span.amnbIn': {
        top: '30px',
        left: '269px',
        position: 'absolute',
      },
      '& span.amNbLeft': {
        top: '155px',
        left: '443px',
        position: 'absolute',
      },
      '& span.amnbEx': {
        top: '30px',
        left: '450px',
        position: 'absolute',
      },
      '& span.amNbMiddle': {
        top: '155px',
        left: '354px',
        position: 'absolute',
      },
      '& span.amNbRight': {
        top: '155px',
        left: '265px',
        position: 'absolute',
      },
      '& span.amsbIn': {
        top: '700px',
        left: '445px',
        position: 'absolute',
      },
      '& span.amsbEx': {
        top: '700px',
        left: '263px',
        position: 'absolute',
      },
      '& span.amebIn': {
        top: '280px',
        left: '725px',
        position: 'absolute',
      },
      '& span.amebEx': {
        top: '445px',
        left: '725px',
        position: 'absolute',
      },
      '& span.amwbIn': {
        top: '445px',
        left: '3px',
        position: 'absolute',
      },
      '& span.amwbEx': {
        top: '280px',
        left: '5px',
        position: 'absolute',
      },
      '& span.amSbLeft': {
        top: '575px',
        left: '265px',
        position: 'absolute',
      },
      '& span.amEbLeft': {
        top: '438px',
        left: '596px',
        position: 'absolute',
      },
      '& span.amWbLeft': {
        top: '280px',
        left: ' 131px',
        position: 'absolute',
      },
      '& span.amSbRight': {
        top: '575px',
        left: '443px',
        position: 'absolute',
      },
      '& span.amEbRight': {
        top: '285px',
        left: '596px',
        position: 'absolute',
      },
      '& span.amWbRight': {
        top: '440px',
        left: ' 131px',
        position: 'absolute',
      },
      '& span.amCenterData': {
        top: '360px',
        left: '370px',
        position: 'absolute',
      },
      '& span.amSbMiddle': {
        top: '575px',
        left: '354px',
        position: 'absolute',
      },
      '& span.amEbMiddle': {
        top: '360px',
        left: '596px',
        position: 'absolute',
      },
      '& span.amWbMiddle': {
        top: '360px',
        left: ' 131px',
        position: 'absolute',
      },
    }
  },



  bicycleMovlData: {
    width: '100%',
    float: 'left',
    position: 'relative',
    textAlign: 'center',
    cursor: 'default',
    '@media only screen and (max-width: 3500px)': {
      '& .arrowImg': {
        width: '18px',
        position: 'absolute',
        top: '30px',
        right: '40px',
        fontSize: '15pt',
      },
      '& span': {
        fontSize: '10pt',
        width: '40px',
        cursor: 'default',
      },
      '& span.amNbLeft': {
        top: '90px',
        left: '242px',
        position: 'absolute',
      },
      '& span.amnbEx': {
        top: '20px',
        left: '243px',
        position: 'absolute',
      },
      '& span.amNbMiddle': {
        top: '90px',
        left: '190px',
        position: 'absolute',
      },
      '& span.amNbRight': {
        top: '90px',
        left: '140px',
        position: 'absolute',
      },      
      '& span.amSbLeft': {
        top: '325px',
        left: '141px',
        position: 'absolute',
      },
      '& span.amEbLeft': {
        top: '256px',
        left: '310px',
        position: 'absolute',
      },
      '& span.amWbLeft': {
        top: '156px',
        left: ' 70px',
        position: 'absolute',
      },
      '& span.amSbRight': {
        top: '325px',
        left: '234px',
        position: 'absolute',
      },
      '& span.amEbRight': {
        top: '155px',
        left: '310px',
        position: 'absolute',
      },
      '& span.amWbRight': {
        top: '255px',
        left: ' 70px',
        position: 'absolute',
      },      
      '& span.amSbMiddle': {
        top: '325px',
        left: '191px',
        position: 'absolute',
      },
      '& span.amEbMiddle': {
        top: '205px',
        left: '310px',
        position: 'absolute',
      },
      '& span.amWbMiddle': {
        top: '204px',
        left: ' 70px',
        position: 'absolute',
      }
    },
    '@media only screen and (min-width: 3501px)': {
      '& .arrowImg': {
        width: '25px',
        position: 'absolute',
        top: '65px',
        right: '85px',
        fontSize: '25pt',
      },
      '& span': {
        fontSize: '18pt',
        width: '90px',
        cursor: 'default',
      },
      '& span.amNbLeft': {
        top: '160px',
        left: '441px',
        position: 'absolute',
      },
      '& span.amNbMiddle': {
        top: '160px',
        left: '350px',
        position: 'absolute',
      },
      '& span.amNbRight': {
        top: '160px',
        left: '260px',
        position: 'absolute',
      },
      '& span.amSbLeft': {
        top: '545px',
        left: '260px',
        position: 'absolute',
      },
      '& span.amEbLeft': {
        top: '420px',
        left: '593px',
        position: 'absolute',
      },
      '& span.amWbLeft': {
        top: '280px',
        left: '118px',
        position: 'absolute',
      },
      '& span.amSbRight': {
        top: '545px',
        left: '442px',
        position: 'absolute',
      },
      '& span.amEbRight': {
        top: '283px',
        left: '593px',
        position: 'absolute',
      },
      '& span.amWbRight': {
        top: '418px',
        left: '118px',
        position: 'absolute',
      },
      '& span.amCenterData': {
        top: '190px',
        left: '196px',
        position: 'absolute',
      },
      '& span.amSbMiddle': {
        top: '545px',
        left: '350px',
        position: 'absolute',
      },
      '& span.amEbMiddle': {
        top: '353px',
        left: '593px',
        position: 'absolute',
      },
      '& span.amWbMiddle': {
        top: '352px',
        left: '118px',
        position: 'absolute',
      },
    },
  },


  pedVolData: {
    position: 'relative',
    width: '100%',
    float: 'left',
    textAlign: 'center',
    cursor: 'default',
    '@media only screen and (max-width: 3500px)': {
      '& .arrowImg': {
        width: '18px',
        position: 'absolute',
        top: '30px',
        right: '40px',
        fontSize: '15pt',
      },
      '& span': {
        width: '40px',
        fontSize: '10pt',
        cursor: 'default',
      },
      '& span.amNbWalk': {
        position: 'absolute',
        top: '85px',
        left: '195px',
      },
      '& span.amSbWalk': {
        position: 'absolute',
        top: '330px',
        left: '188px',
      },
      '& span.amEbWalk': {
        top: '205px',
        left: '313px',
        position: 'absolute',
      },
      '& span.amWbWalk': {
        position: 'absolute',
        left: '70px',
        top: '210px',
      }
    },
    '@media only screen and (min-width: 3501px)': {
      '& .arrowImg': {
        width: '25px',
        position: 'absolute',
        top: '50px',
        right: '85px',
        fontSize: '25pt',
      },
      '& span': {
        width: '90px',
        fontSize: '18pt',
        cursor: 'default',
      },
      '& span.amNbWalk': {
        position: 'absolute',
        top: '135px',
        left: '355px',
      },
      '& span.amSbWalk': {
        position: 'absolute',
        top: '570px',
        left: '354px',
      },
      '& span.amEbWalk': {
        top: '350px',
        left: '610px',
        position: 'absolute',
      },
      '& span.amWbWalk': {
        position: 'absolute',
        top: '350px',
        left: '100px',
      }
    }
  }

}));
//End Css code ...


let turingImgSrc = require("./../../assets/images/turning.svg");
let trackImage = require("./../../assets/images/truck.svg");
let bicycleImage = require("./../../assets/images/cycle.svg");
let pedestrianImage = require("./../../assets/images/Walk.svg");

//Start AMTab component code ...
const AMLayers = (props) => {
  const classes = useStyles();
  const [intersectionImagesAm, setIntersectionImagesAm] = React.useState(turingImgSrc);
  const [turningCountData, setTurningCountData] = React.useState(
    {
      nbIn: 0,
      nbEx: 0,
      sbIn: 0,
      sbEx: 0,
      ebIn: 0,
      ebEx: 0,
      wbIn: 0,
      wbEx: 0,
      nbLeft: 0,
      sbLeft: 0,
      ebLeft: 0,
      wbLeft: 0,
      nbRight: 0,
      sbRight: 0,
      ebRight: 0,
      wbRight: 0,
      nbMiddle: 0,
      sbMiddle: 0,
      ebMiddle: 0,
      wbMiddle: 0,
      centerData: 0,     
      nuturn:0,
      suturn:0,
      euturn:0,
      wsuturn:0
    });
  const [truckCountData, setTruckCountData] = React.useState({ nbIn: 0, nbEx: 0, sbIn: 0, sbEx: 0, ebIn: 0, ebEx: 0, wbIn: 0, wbEx: 0, nbLeft: 0, sbLeft: 0, ebLeft: 0, wbLeft: 0, nbRight: 0, sbRight: 0, ebRight: 0, wbRight: 0, nbMiddle: 0, sbMiddle: 0, ebMiddle: 0, wbMiddle: 0,nuturn:0,suturn:0,euturn:0,wsuturn:0 });
  const [pedestrianData, setPedestrianData] = React.useState({ pedNb: 0, pedSb: 0, pedEb: 0, pedWb: 0 });

  const [bicycleCountData, setBicycleCountData] = React.useState({ nbLeft: 0, sbLeft: 0, ebLeft: 0, wbLeft: 0, nbRight: 0, sbRight: 0, ebRight: 0, wbRight: 0, nbMiddle: 0, sbMiddle: 0, ebMiddle: 0, wbMiddle: 0 });

  const [turnBlock, setTurnBlock] = React.useState('block');
  const [truckBlock, setTruckBlock] = React.useState('none');
  const [pedestBlock, setPedestBlock] = React.useState('none');
  const [bicycleBlock, setBicycleBlock] = React.useState('none');
  const [startPeakHour, setStartPeakHour] = React.useState(null);
  const [endPeakHour, setEndPeakHour] = React.useState(null);
  const [startPeakMin, setStartPeakMin] = React.useState(null);
  const [endPeakMin, setEndPeakMin] = React.useState(null);
  const [getValueDrop, setValueDrop] = React.useState(null);

  React.useEffect(
    () => {

      if (props.AMdata && props.AMdata.hour && props.AMdata.hour.startdate && props.AMdata.hour.enddate) {
        setStartPeakHour(props.AMdata.hour.startdate);
        setEndPeakHour(props.AMdata.hour.enddate);
      } else {
        setStartPeakHour(null);
        setEndPeakHour(null);
      }

      if (props.AMdata && props.AMdata.minute && props.AMdata.minute.startdate && props.AMdata.minute.enddate) {
        setStartPeakMin(props.AMdata.minute.startdate);
        setEndPeakMin(props.AMdata.minute.enddate);
      } else {
        setStartPeakMin(null);
        setEndPeakMin(null);
      }

      if (props.AMdata && props.AMdata.startdate && props.AMdata.enddate) {
        getTurningMovement();
        getTruckPercentage();
        getPedestrianMovement();
        getBicycleMovement();
      }
      if (props.getIntersectionDrop !== null) {
        setImage(props.getIntersectionDrop)
        setValueDrop(props.getIntersectionDrop)
      }
    }, [props.AMdata, props.stationId, props.getIntersectionDrop]);

  const changeAmImages = e => {
    e.preventDefault();
    let checkValue = e.target.value;
    setValueDrop(checkValue)
    props.onChangeMethod(checkValue)
    setImage(checkValue);
  }

  const setImage = checkValue => {
    if (checkValue == 0) {
      getTurningMovement();
      setTurnBlock('block');
      setTruckBlock('none');
      setPedestBlock('none');
      setBicycleBlock('none');
      setIntersectionImagesAm(turingImgSrc);
    }
    else if (checkValue == 1) {
      getTruckPercentage();
      setTurnBlock('none');
      setTruckBlock('block');
      setPedestBlock('none');
      setBicycleBlock('none');
      setIntersectionImagesAm(trackImage);
    }
    else if (checkValue == 2) {
      getPedestrianMovement();
      setTurnBlock('none');
      setTruckBlock('none');
      setPedestBlock('block');
      setBicycleBlock('none');
      setIntersectionImagesAm(pedestrianImage);
    }
    else {
      getBicycleMovement();
      setTurnBlock('none');
      setTruckBlock('none');
      setPedestBlock('none');
      setBicycleBlock('block');
      setIntersectionImagesAm(bicycleImage);
    }
  }

  //This method is use for API call to get Turning Movement Data .... Start
  const getTurningMovement = () => {
    let amDataStart;
    let amDataEnd;
    if (props.AMdata.hour) {
      amDataStart = props.AMdata.hour.peakstartdate;
      amDataEnd = props.AMdata.hour.peakenddate;
    }
    else {
      amDataStart = "";
      amDataEnd = "";
    }
    try {
      axios({
        method: 'post',
        url: API_URL + API_PATH.getTurningMovement,
        data: {
          "stationId": props.stationId,
          "start": amDataStart,
          "end": amDataEnd,
          "hour_volume": props.AMdata.hour.volume,
          "minute_volume": props.AMdata.minute.volume
        }
      }).then(function (response) {
        if (response && response.data.data) {
          let data = response.data.data;
          setTurningCountData({
            nbIn: data.north.in ? data.north.in : 0,
            nbEx: data.north.out ? data.north.out : 0,
            sbIn: data.south.in ? data.south.in : 0,
            sbEx: data.south.out ? data.south.out : 0,
            ebIn: data.east.in ? data.east.in : 0,
            ebEx: data.east.out ? data.east.out : 0,
            wbIn: data.west.in ? data.west.in : 0,
            wbEx: data.west.out ? data.west.out : 0,
            nbLeft: data.north.left ? data.north.left : 0,
            sbLeft: data.south.left ? data.south.left : 0,
            ebLeft: data.east.left ? data.east.left : 0,
            wbLeft: data.west.left ? data.west.left : 0,
            nbRight: data.north.right ? data.north.right : 0,
            sbRight: data.south.right ? data.south.right : 0,
            ebRight: data.east.right ? data.east.right : 0,
            wbRight: data.west.right ? data.west.right : 0,
            nbMiddle: data.north.middle ? data.north.middle : 0,
            sbMiddle: data.south.middle ? data.south.middle : 0,
            ebMiddle: data.east.middle ? data.east.middle : 0,
            wbMiddle: data.west.middle ? data.west.middle : 0,
            centerData: data.phf ? data.phf : 0,
            nuturn: data.north.uturn ? data.north.uturn : 0,
            suturn: data.south.uturn ? data.south.uturn : 0,
            euturn: data.east.uturn ? data.east.uturn : 0,
            wsuturn: data.west.uturn ? data.west.uturn : 0 
          })
        } else {
          setTurningCountData({ nbIn: 0, nbEx: 0, sbIn: 0, sbEx: 0, ebIn: 0, ebEx: 0, wbIn: 0, wbEx: 0, nbLeft: 0, sbLeft: 0, ebLeft: 0, wbLeft: 0, nbRight: 0, sbRight: 0, ebRight: 0, wbRight: 0, nbMiddle: 0, sbMiddle: 0, ebMiddle: 0, wbMiddle: 0, centerData: 0,nuturn:0,suturn:0,euturn:0,wsuturn:0 });
        }
      })
        .catch(function (error) {
          setTurningCountData({ nbIn: 0, nbEx: 0, sbIn: 0, sbEx: 0, ebIn: 0, ebEx: 0, wbIn: 0, wbEx: 0, nbLeft: 0, sbLeft: 0, ebLeft: 0, wbLeft: 0, nbRight: 0, sbRight: 0, ebRight: 0, wbRight: 0, nbMiddle: 0, sbMiddle: 0, ebMiddle: 0, wbMiddle: 0, centerData: 0,nuturn:0,suturn:0,euturn:0,wsuturn:0 });
        })
    }
    catch (error) {
      setTurningCountData({ nbIn: 0, nbEx: 0, sbIn: 0, sbEx: 0, ebIn: 0, ebEx: 0, wbIn: 0, wbEx: 0, nbLeft: 0, sbLeft: 0, ebLeft: 0, wbLeft: 0, nbRight: 0, sbRight: 0, ebRight: 0, wbRight: 0, nbMiddle: 0, sbMiddle: 0, ebMiddle: 0, wbMiddle: 0, centerData: 0,nuturn:0,suturn:0,euturn:0,wsuturn:0 });
    }
  }
  //This method is use for API call to get Turning Movement Data .... End


  //This method is use for API call to get Truck Percentage Data .... Start
  const getTruckPercentage = () => {
    let amDataStart;
    let amDataEnd;
    if (props.AMdata.hour) {
      amDataStart = props.AMdata.hour.peakstartdate;
      amDataEnd = props.AMdata.hour.peakenddate;
    }
    else {
      amDataStart = "";
      amDataEnd = "";
    }
    try {
      axios({
        method: 'post',
        url: API_URL + API_PATH.getTruckPercentage,
        data: {
          "stationId": props.stationId,
          "start": amDataStart,
          "end": amDataEnd,
        }
      }).then(function (response) {
        if (response && response.data.data) {
          let data = response.data.data;
          setTruckCountData({
            nbIn: data.north.in ? data.north.in : 0,
            nbEx: data.north.out ? data.north.out : 0,
            sbIn: data.south.in ? data.south.in : 0,
            sbEx: data.south.out ? data.south.out : 0,
            ebIn: data.east.in ? data.east.in : 0,
            ebEx: data.east.out ? data.east.out : 0,
            wbIn: data.west.in ? data.west.in : 0,
            wbEx: data.west.out ? data.west.out : 0,
            nbLeft: data.north.left ? data.north.left : 0,
            sbLeft: data.south.left ? data.south.left : 0,
            ebLeft: data.east.left ? data.east.left : 0,
            wbLeft: data.west.left ? data.west.left : 0,
            nbRight: data.north.right ? data.north.right : 0,
            sbRight: data.south.right ? data.south.right : 0,
            ebRight: data.east.right ? data.east.right : 0,
            wbRight: data.west.right ? data.west.right : 0,
            nbMiddle: data.north.middle ? data.north.middle : 0,
            sbMiddle: data.south.middle ? data.south.middle : 0,
            ebMiddle: data.east.middle ? data.east.middle : 0,
            wbMiddle: data.west.middle ? data.west.middle : 0,
            nuturn: data.north.uturn ? data.north.uturn : 0,
            suturn: data.south.uturn ? data.south.uturn : 0,
            euturn: data.east.uturn ? data.east.uturn : 0,
            wsuturn: data.west.uturn ? data.west.uturn : 0
          });
        } else {
          setTruckCountData({ nbIn: 0, nbEx: 0, sbIn: 0, sbEx: 0, ebIn: 0, ebEx: 0, wbIn: 0, wbEx: 0, nbLeft: 0, sbLeft: 0, ebLeft: 0, wbLeft: 0, nbRight: 0, sbRight: 0, ebRight: 0, wbRight: 0, nbMiddle: 0, sbMiddle: 0, ebMiddle: 0, wbMiddle: 0,nuturn:0,suturn:0,euturn:0,wsuturn:0 });
        }
      })
        .catch(function (error) {
          setTruckCountData({ nbIn: 0, nbEx: 0, sbIn: 0, sbEx: 0, ebIn: 0, ebEx: 0, wbIn: 0, wbEx: 0, nbLeft: 0, sbLeft: 0, ebLeft: 0, wbLeft: 0, nbRight: 0, sbRight: 0, ebRight: 0, wbRight: 0, nbMiddle: 0, sbMiddle: 0, ebMiddle: 0, wbMiddle: 0,nuturn:0,suturn:0,euturn:0,wsuturn:0 });
        })
    }
    catch (error) {
      setTruckCountData({ nbIn: 0, nbEx: 0, sbIn: 0, sbEx: 0, ebIn: 0, ebEx: 0, wbIn: 0, wbEx: 0, nbLeft: 0, sbLeft: 0, ebLeft: 0, wbLeft: 0, nbRight: 0, sbRight: 0, ebRight: 0, wbRight: 0, nbMiddle: 0, sbMiddle: 0, ebMiddle: 0, wbMiddle: 0,nuturn:0,suturn:0,euturn:0,wsuturn:0 });
    }
  }
  //This method is use for API call to get Truck Percentage Data .... End

  //This method is use for API call to get Pedestrian Movement Data .... Start
  const getPedestrianMovement = () => {
    let amDataStart;
    let amDataEnd;
    if (props.AMdata.hour) {
      amDataStart = props.AMdata.hour.peakstartdate;
      amDataEnd = props.AMdata.hour.peakenddate;
    }
    else {
      amDataStart = "";
      amDataEnd = "";
    }
    try {
      axios({
        method: 'post',
        url: API_URL + API_PATH.getPedestrianMovement,
        data: {
          "stationId": props.stationId,
          "start": amDataStart,
          "end": amDataEnd,
        }
      }).then(function (response) {
        if (response && response.data.data) {
          let data = response.data.data;
          setPedestrianData({
            pedNb: data.north.middle ? data.north.middle : 0, pedSb: data.south.middle ? data.south.middle : 0, pedEb: data.east.middle ? data.east.middle : 0, pedWb: data.west.middle ? data.west.middle : 0
          });
        } else {
          setPedestrianData({ pedNb: 0, pedSb: 0, pedEb: 0, pedWb: 0 });
        }
      })
        .catch(function (error) {
          setPedestrianData({ pedNb: 0, pedSb: 0, pedEb: 0, pedWb: 0 });
        })
    }
    catch (error) {
      setPedestrianData({ pedNb: 0, pedSb: 0, pedEb: 0, pedWb: 0 });
    }
  }
  //This method is use for API call to get Pedestrian Movement Data .... End


  //This method is use for API call to get Bicycle Movement Data .... Start
  const getBicycleMovement = () => {
    let amDataStart;
    let amDataEnd;
    if (props.AMdata.hour) {
      amDataStart = props.AMdata.hour.peakstartdate;
      amDataEnd = props.AMdata.hour.peakenddate;
    }
    else {
      amDataStart = "";
      amDataEnd = "";
    }
    try {
      axios({
        method: 'post',
        url: API_URL + API_PATH.getBicycleMovement,
        data: {
          "stationId": props.stationId,
          "start": amDataStart,
          "end": amDataEnd,
        }
      }).then(function (response) {
        if (response && response.data.data) {
          let data = response.data.data;
          setBicycleCountData({
            nbLeft: data.north.left ? data.north.left : 0,
            sbLeft: data.south.left ? data.south.left : 0,
            ebLeft: data.east.left ? data.east.left : 0,
            wbLeft: data.west.left ? data.west.left : 0,
            nbRight: data.north.right ? data.north.right : 0,
            sbRight: data.south.right ? data.south.right : 0,
            ebRight: data.east.right ? data.east.right : 0,
            wbRight: data.west.right ? data.west.right : 0,
            nbMiddle: data.north.middle ? data.north.middle : 0,
            sbMiddle: data.south.middle ? data.south.middle : 0,
            ebMiddle: data.east.middle ? data.east.middle : 0,
            wbMiddle: data.west.middle ? data.west.middle : 0,
          });
        } else {
          setBicycleCountData({ nbLeft: 0, sbLeft: 0, ebLeft: 0, wbLeft: 0, nbRight: 0, sbRight: 0, ebRight: 0, wbRight: 0, nbMiddle: 0, sbMiddle: 0, ebMiddle: 0, wbMiddle: 0 });
        }
      })
        .catch(function (error) {
          setBicycleCountData({ nbLeft: 0, sbLeft: 0, ebLeft: 0, wbLeft: 0, nbRight: 0, sbRight: 0, ebRight: 0, wbRight: 0, nbMiddle: 0, sbMiddle: 0, ebMiddle: 0, wbMiddle: 0 });
        })
    }
    catch (error) {
      setBicycleCountData({ nbLeft: 0, sbLeft: 0, ebLeft: 0, wbLeft: 0, nbRight: 0, sbRight: 0, ebRight: 0, wbRight: 0, nbMiddle: 0, sbMiddle: 0, ebMiddle: 0, wbMiddle: 0 });
    }
  }
  //This method is use for API call to get Bicycle Movement Data .... End


  return (
    <React.Fragment>
      <div className={classes.mainbtnDiv} style={{ padding: '10px' }} data-testid="AMtab">
        <div className='left'><span>AM Peak Hour:</span></div><div className='right'>
          {startPeakHour && endPeakHour ? <span>{startPeakHour}  - {endPeakHour}  </span> : <span>NA </span>}</div>
        <div className='left'><span>AM Peak 15-Min:</span></div><div className='right'>
          {startPeakMin && endPeakMin ? <span>{startPeakMin}  - {endPeakMin}  </span> : <span>NA </span>}</div>
        <select id="date" value={getValueDrop} style={{ marginTop: '10px' }} className={classes.intersectionDrop} onChange={(e) => { changeAmImages(e) }}>
          <option value={0}>Turning Movements</option>
          <option value={1}>Truck Percentages </option>
          <option value={2}>Pedestrian Volumes</option>
          <option value={3}>Bicycle Movements</option>
        </select>
        <div className={classes.turningCountData} style={{ display: turnBlock }}>
          <img src={intersectionImagesAm} style={{ width: "95%", marginTop: '15px', padding:'25px' }} />
          {/*<div className='arrowImg'><img src={require("./../../assets/images/intersectionArrow.svg")} style={{ width: "100%", marginBottom: '-10px' }} /><br />N</div>*/}
          <span className='amnbIn'>{turningCountData.sbIn}</span>
          <span className='amnbEx'>{turningCountData.sbEx}</span>
          <span className='amsbIn'>{turningCountData.nbIn}</span>
          <span className='amsbEx'>{turningCountData.nbEx}</span>
          <span className='amebIn'>{turningCountData.wbIn}</span>
          <span className='amebEx'>{turningCountData.wbEx}</span>
          <span className='amwbIn'>{turningCountData.ebIn}</span>
          <span className='amwbEx'>{turningCountData.ebEx}</span>
          <span className='amNbLeft'>{turningCountData.sbLeft}</span>
          <span className='amSbLeft'>{turningCountData.nbLeft}</span>
          <span className='amEbLeft'>{turningCountData.wbLeft}</span>
          <span className='amWbLeft'>{turningCountData.ebLeft}</span>
          <span className='amNbRight'>{turningCountData.sbRight}</span>
          <span className='amSbRight'>{turningCountData.nbRight}</span>
          <span className='amEbRight'>{turningCountData.wbRight}</span>
          <span className='amWbRight'>{turningCountData.ebRight}</span>
          <span className='amCenterData' title='Peak Hour Factor'>{turningCountData.centerData}</span>
          <span className='amNbMiddle'>{turningCountData.sbMiddle}</span>
          <span className='amSbMiddle'>{turningCountData.nbMiddle}</span>
          <span className='amEbMiddle'>{turningCountData.wbMiddle}</span>
          <span className='amWbMiddle'>{turningCountData.ebMiddle}</span>

          <span className='nUturn'>{turningCountData.suturn}</span>
          <span className='sUturn'>{turningCountData.nuturn}</span>
          <span className='eUturn'>{turningCountData.wsuturn}</span>
          <span className='wUturn'>{turningCountData.euturn}</span>
        </div>
        <div className={classes.truckMovData} style={{ display: truckBlock }}>
          <img src={intersectionImagesAm} style={{ width: "95%", marginTop: '15px', padding:'25px' }} />
          {/*<div className='arrowImg'><img src={require("./../../assets/images/intersectionArrow.svg")} style={{ width: "100%", marginBottom: '-10px' }} /><br />N</div>*/}
          <span className='amnbIn'>{truckCountData.sbIn}</span>
          <span className='amnbEx'>{truckCountData.sbEx}</span>
          <span className='amsbIn'>{truckCountData.nbIn}</span>
          <span className='amsbEx'>{truckCountData.nbEx}</span>
          <span className='amebIn'>{truckCountData.wbIn}</span>
          <span className='amebEx'>{truckCountData.wbEx}</span>
          <span className='amwbIn'>{truckCountData.ebIn}</span>
          <span className='amwbEx'>{truckCountData.ebEx}</span>
          <span className='amNbLeft'>{truckCountData.sbLeft}</span>
          <span className='amSbLeft'>{truckCountData.nbLeft}</span>
          <span className='amEbLeft'>{truckCountData.wbLeft}</span>
          <span className='amWbLeft'>{truckCountData.ebLeft}</span>
          <span className='amNbRight'>{truckCountData.sbRight}</span>
          <span className='amSbRight'>{truckCountData.nbRight}</span>
          <span className='amEbRight'>{truckCountData.wbRight}</span>
          <span className='amWbRight'>{truckCountData.ebRight}</span>
          <span className='amCenterData'>&nbsp;</span>
          <span className='amNbMiddle'>{truckCountData.sbMiddle}</span>
          <span className='amSbMiddle'>{truckCountData.nbMiddle}</span>
          <span className='amEbMiddle'>{truckCountData.wbMiddle}</span>
          <span className='amWbMiddle'>{truckCountData.ebMiddle}</span>

          <span className='nUturn'>{truckCountData.suturn}</span>
          <span className='sUturn'>{truckCountData.nuturn}</span>
          <span className='eUturn'>{truckCountData.wsuturn}</span>
          <span className='wUturn'>{truckCountData.euturn}</span>
        </div>
        <div className={classes.pedVolData} style={{ display: pedestBlock }}>
          <img src={intersectionImagesAm} style={{ width: "95%", marginTop: '15px', padding:'25px' }} />
          {/*<div className='arrowImg'><img src={require("./../../assets/images/intersectionArrow.svg")} style={{ width: "100%", marginBottom: '-10px' }} /><br />N</div>*/}
          <span className='amNbWalk'>{pedestrianData.pedSb}</span>
          <span className='amSbWalk'>{pedestrianData.pedNb}</span>
          <span className='amEbWalk'>{pedestrianData.pedWb}</span>
          <span className='amWbWalk'>{pedestrianData.pedEb}</span>
        </div>
        <div className={classes.bicycleMovlData} style={{ display: bicycleBlock }}>
          <img src={intersectionImagesAm} style={{ width: "95%", marginTop: '15px', padding:'25px' }} />
          {/*<div className='arrowImg'><img src={require("./../../assets/images/intersectionArrow.svg")} style={{ width: "100%", marginBottom: '-10px' }} /><br />N</div>*/}
          <span className='amNbLeft'>{bicycleCountData.sbLeft}</span>
          <span className='amSbLeft'>{bicycleCountData.nbLeft}</span>
          <span className='amEbLeft'>{bicycleCountData.wbLeft}</span>
          <span className='amWbLeft'>{bicycleCountData.ebLeft}</span>
          <span className='amNbRight'>{bicycleCountData.sbRight}</span>
          <span className='amSbRight'>{bicycleCountData.nbRight}</span>
          <span className='amEbRight'>{bicycleCountData.wbRight}</span>
          <span className='amWbRight'>{bicycleCountData.ebRight}</span>
          <span className='amNbMiddle'>{bicycleCountData.sbMiddle}</span>
          <span className='amSbMiddle'>{bicycleCountData.nbMiddle}</span>
          <span className='amEbMiddle'>{bicycleCountData.wbMiddle}</span>
          <span className='amWbMiddle'>{bicycleCountData.ebMiddle}</span>
        </div>
      </div>
    </React.Fragment>
  );
}

export default AMLayers;

//End AMTab component code ...
